<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="detailsContent">
      <birthVideo :type='type' :id='id'></birthVideo>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import birthVideo from '@/components/birthdayVideo'
export default {
  data () {
    return {
      navBlock: '新聞  /  生日視頻',
      navtitle:'編輯視頻',
      type:'edit',
      id: this.$route.query.id,
    }
  },
  components: {
    NavBar,
    birthVideo
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/news/birthdayVideo/editBirthVideo.vue